<template>
  <div class="ai-name-big-tree-container" :style="containerStyle">
    <svg :width="svgWidth" :height="svgHeight" viewBox="0 0 96 233" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <title>aiNameBigTree</title>
      <defs>
        <filter x="-3.5%" y="-2.6%" width="106.9%" height="105.2%" filterUnits="objectBoundingBox" :id="filterId1">
          <feGaussianBlur stdDeviation="1 0" in="SourceGraphic"></feGaussianBlur>
        </filter>
        <filter x="-1.7%" y="-1.3%" width="103.3%" height="102.6%" filterUnits="objectBoundingBox" :id="filterId2">
          <feGaussianBlur stdDeviation="0.5 0" in="SourceGraphic"></feGaussianBlur>
        </filter>
      </defs>
      <g id="首页" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="首页-ai选题-已生成" transform="translate(-860.000000, -5898.000000)">
          <g id="第二部分备份-3" transform="translate(0.000000, 4851.000000)">
            <g id="位图备份" transform="translate(126.000000, 689.625592)">
              <g id="编组-71" transform="translate(581.000000, 316.374408)">
                <g id="编组" transform="translate(156.631336, 43.000000)">
                  <path d="M8.46841957,116 C41.7168362,116.672623 63.8321729,119.727684 74.8144298,125.165182 C85.5864735,129.384514 90.5984613,129.384514 89.8503933,125.165182 L85.3323237,122.736261 C63.0496907,115.387431 40.1705562,111.713016 16.69492,111.713016 C10.2672212,112.880023 7.52505436,114.309017 8.46841957,116 Z" id="路径-64" :fill="fillColor1"></path>
                  <g id="编组-73" transform="translate(0.000000, 113.000000)" :fill="fillColor2">
                    <path d="M86.1273093,0 C67.045033,1.22312067 53.8372282,25.2940588 46.5038949,72.2128144 C40.0175349,97.0169691 24.5162366,110.194435 0,111.745212 L0,114.857385 C12.4436923,115.366427 23.2311611,112.112796 32.3624063,105.096491 C41.4936516,98.0801867 47.6157998,87.1189611 50.7288508,72.2128144 C53.8427393,56.0034105 57.2509448,42.8126351 60.9534673,32.6404884 C66.507251,17.3822683 70.737548,9.25597894 83.4875888,2.86065398 L86.6835708,2.22280132 L86.1273093,0 Z" id="路径-7" transform="translate(43.341785, 57.454517) scale(1, -1) translate(-43.341785, -57.454517) "></path>
                    <path d="M86.1273093,0 C67.045033,1.22312067 53.8372282,25.2940588 46.5038949,72.2128144 C40.0175349,97.0169691 24.5162366,110.194435 0,111.745212 L0,114.857385 C12.4436923,115.366427 23.2311611,112.112796 32.3624063,105.096491 C41.4936516,98.0801867 47.6157998,87.1189611 50.7288508,72.2128144 C53.8427393,56.0034105 57.2509448,42.8126351 60.9534673,32.6404884 C66.507251,17.3822683 70.737548,9.25597894 83.4875888,2.86065398 L86.6835708,2.22280132 L86.1273093,0 Z" id="路径-7" :filter="filterUrl1" transform="translate(43.341785, 57.454517) scale(1, -1) translate(-43.341785, -57.454517) "></path>
                  </g>
                  <g id="编组-69" :fill="fillColor3">
                    <path d="M86.1273093,0 C67.045033,1.22312067 53.8372282,25.2940588 46.5038949,72.2128144 C40.0175349,97.0169691 24.5162366,110.194435 0,111.745212 L0,114.857385 C12.4436923,115.366427 23.2311611,112.112796 32.3624063,105.096491 C41.4936516,98.0801867 47.6157998,87.1189611 50.7288508,72.2128144 C53.8427393,56.0034105 57.2509448,42.8126351 60.9534673,32.6404884 C66.507251,17.3822683 74.2620694,8.25246782 87.0121101,1.85714286 L90.2080921,1.21929021 L86.1273093,0 Z" id="路径-7" :filter="filterUrl2"></path>
                    <path d="M86.1273093,0 C67.045033,1.22312067 53.8372282,25.2940588 46.5038949,72.2128144 C40.0175349,97.0169691 24.5162366,110.194435 0,111.745212 L0,114.857385 C12.4436923,115.366427 23.2311611,112.112796 32.3624063,105.096491 C41.4936516,98.0801867 47.6157998,87.1189611 50.7288508,72.2128144 C53.8427393,56.0034105 57.2509448,42.8126351 60.9534673,32.6404884 C66.507251,17.3822683 74.2620694,8.25246782 87.0121101,1.85714286 L90.2080921,1.21929021 L86.1273093,0 Z" id="路径-7"></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'AiNameBigTree',
  props: {
    width: {
      type: Number,
      default: 96
    },
    fillColor1: {
      type: String,
      default: '#F6A04D'
    },
    fillColor2: {
      type: String,
      default: '#9E82D9'
    },
    fillColor3: {
      type: String,
      default: '#4D7DE9'
    },
    /** 同一页多个实例时需传入唯一前缀，避免 SVG filter id 冲突导致图形不显示 */
    filterUid: {
      type: String,
      default: ''
    }
  },
  computed: {
    filterId1 () {
      const u = this.filterUid || 'abt-big'
      return `${u}-f1`
    },
    filterId2 () {
      const u = this.filterUid || 'abt-big'
      return `${u}-f2`
    },
    filterUrl1 () {
      return `url(#${this.filterId1})`
    },
    filterUrl2 () {
      return `url(#${this.filterId2})`
    },
    svgWidth () {
      return this.width
    },
    svgHeight () {
      // 保持原始宽高比 96:233
      return (this.width * 233) / 96
    },
    containerStyle () {
      return {
        display: 'inline-block',
        verticalAlign: 'middle'
      }
    }
  }
}
</script>

<style scoped>
.ai-name-big-tree-container {
  display: inline-block;
  vertical-align: middle;
}

svg {
  max-width: 100%;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/ai-name-big-tree/ai-name-big-tree.vue